import React from 'react';
import PropTypes from 'prop-types';
import BaseCell from '../base-cell/index';

export default class LargeImageCell extends BaseCell {

  render() {
    const {url, additional_url} = this.props;

    return (
      <div className={'cu-ui-message cu-ui-message-full-image'}>
        <div className={'cu-ui-message-block cu-ui-text-count-data'} { ...this.textCountCustomAttributes }>
          <div className='cu-ui-message-content cu-ui-message-image' tabIndex="0">
            <a href={ additional_url ? additional_url : url} target="_blank">
              <img src={url} />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

LargeImageCell.propTypes = {
  url: PropTypes.string
};
